module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":"CSV出力","format":{"flying_only":"従来フォーマット（ライトトラップのみ）","crawling_aware":"床置きトラップ対応版"},"error":{"selectData":"CSV出力するデータを選択して下さい"}},"en":{"label":"CSV Download","format":{"flying_only":"Flying-only format","crawling_aware":"Crawling-aware version"},"error":{"selectData":"Select the data for which you want to download as CSV."}}}')
  delete Component.options._Ctor
}
